import { render, staticRenderFns } from "./FoodItem.vue?vue&type=template&id=770683c9&"
import script from "./FoodItem.vue?vue&type=script&lang=js&"
export * from "./FoodItem.vue?vue&type=script&lang=js&"
import style0 from "./FoodItem.vue?vue&type=style&index=0&id=770683c9&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports